/* eslint-disable import/no-unresolved */
import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { EmptyTransactionsImage } from 'assets/components';

const EmptyTransactionsPage = ({ emptySearchResult, isDisabled }) => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const { t: translate } = useTranslation();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <EmptyTransactionsImage emptySearchResult={emptySearchResult} />
      <b className="text-f4 text-white mt-4">
        {emptySearchResult
          ? translate('search_no_results_found_label')
          : translate('no_transactions_note')}
      </b>
      <b className="text-f6 text-shadow mt-2">
        {emptySearchResult
          ? translate('search_try_different_criteria_label')
          : translate('no_transactions_note_add')}
      </b>
      {!emptySearchResult && (
        <button
          type="button"
          disabled={isDisabled}
          className={`btn ${
            isDisabled ? 'btn-disabled btn-sm px-4 py-2' : 'btn-primary'
          } rounded-4 mt-4 d-flex align-items-center`}
          style={{ padding: !isDisabled ? '0.615rem 2rem' : '' }}
          onClick={() => {
            history.push(`${path}/accounts`);
          }}>
          <b className="text-f6">{translate('topup_button_label')}</b>
        </button>
      )}
    </div>
  );
};

export default EmptyTransactionsPage;

EmptyTransactionsPage.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  emptySearchResult: PropTypes.bool.isRequired,
};
